export const CONFIRM_APPOINTMENT = 'CONFIRM_SELECTED_APPOINTMENT';
export type CONFIRM_APPOINTMENT = typeof CONFIRM_APPOINTMENT;

export const SHOW_CONFIRMATION_SECTION = 'SHOW_CONFIRMATION_SECTION';
export type SHOW_CONFIRMATION_SECTION = typeof SHOW_CONFIRMATION_SECTION;

export const STAGE_APPOINTMENTS = 'STAGE_APPOINTMENTS';
export type STAGE_APPOINTMENTS = typeof STAGE_APPOINTMENTS;


// WEBPACK FOOTER //
// ./src/store/Appointment/constants.ts